import { Injectable } from '@angular/core';
import { Observable, combineLatest, map, distinctUntilChanged, filter, take, shareReplay, switchMap } from 'rxjs';
import { CommonService } from './common.service';
import { OrganizationLevelService } from './organizationLevel.service';
import { ORG_LEVEL_OVERRIDE_KEY } from 'src/app/common-components/widget-org-filter/widget-org-filter.component';

@Injectable({ providedIn: 'root' })
export class WidgetOrgResolverService {
  constructor(
    private commonService: CommonService,
    private organizationLevelService: OrganizationLevelService,
  ) {}

  getEffectiveOrgId(widgetConfig: Record<string, unknown>): string | undefined {
    const override = widgetConfig[ORG_LEVEL_OVERRIDE_KEY] as string | null | undefined;
    if (override != null) return override;
    return this.commonService.selectedOrgEmitter.value?.id ?? undefined;
  }

  effectiveOrgId$(widgetConfig$: Observable<Record<string, unknown>>): Observable<string> {
    return combineLatest([widgetConfig$, this.commonService.selectedOrgEmitter]).pipe(
      map(([config, org]) => {
        const override = config[ORG_LEVEL_OVERRIDE_KEY] as string | null | undefined;
        if (override != null) return override;
        return org?.id ?? undefined;
      }),
      filter((id): id is string => id != null),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  lostAccess$(widgetConfig$: Observable<Record<string, unknown>>): Observable<true> {
    return widgetConfig$.pipe(
      map(config => config[ORG_LEVEL_OVERRIDE_KEY] as string | null | undefined),
      filter((override): override is string => override != null),
      take(1),
      switchMap(override => this.organizationLevelService.getAll().pipe(
        filter(orgs => !orgs.some(o => o.id === override)),
        take(1),
        map(() => true as const),
      )),
    );
  }
}
